import Bridge from './Bridge'

BS.DOMReady(() => {
	[].forEach.call(document.querySelectorAll('.js-tag-select-replace'), el => {
		// オプションを読み込む
		const optionDiv = el.parentNode
		const optionJson = optionDiv.getAttribute('data-tag-select-options')
		const options = optionJson ? JSON.parse(optionJson) : null

		new Bridge(el, options)
	})
})
